// Decodes the JWT stored by the login flow and exposes simple admin-gating helpers.
// The backend (AuthController.CreateJwtToken) signs tokens with a "role" claim
// (short JWT name for ClaimTypes.Role) — "Admin" for panel operators, "User" otherwise.

function decodeToken(token) {
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const json = decodeURIComponent(
            atob(base64)
                .split('')
                .map((c) => '%' + c.charCodeAt(0).toString(16).padStart(2, '0'))
                .join('')
        );
        return JSON.parse(json);
    } catch {
        return null;
    }
}

/** Reads and validates the stored token, returning its payload or null if
 * missing, malformed, or expired. Expiry is checked client-side purely to
 * avoid flashing stale UI — the API independently re-validates every request. */
export function getValidTokenPayload() {
    const token = localStorage.getItem('token');
    if (!token) return null;
    const payload = decodeToken(token);
    if (!payload) return null;
    if (payload.exp && Date.now() >= payload.exp * 1000) return null;
    return payload;
}

export function isAdminSession() {
    const payload = getValidTokenPayload();
    return !!payload && payload.role === 'Admin';
}
